import cn from 'classnames';
import { IReviewsStats } from 'src/interfaces/reviews';

import { Icon, Space, Typography } from '@sravni/react-design-system';

import styles from './block.module.scss';

interface IBlockProps {
  isReviewsCount: boolean;
  reviewsStats?: IReviewsStats;
  description: string;
  icon: React.ReactElement;
}

const getRecommendedValue = (positivesCount: number, negativesCount: number): number => {
  if (!positivesCount) return null;
  if (!negativesCount) return 100;
  return Math.round((positivesCount / (positivesCount + negativesCount)) * 100);
};

export const Block = ({ isReviewsCount, reviewsStats, description, icon }: IBlockProps) => {
  const { positivesCount, negativesCount, reviewsCount } = reviewsStats || {};
  const recommended = getRecommendedValue(positivesCount, negativesCount);

  const isRecomendBlockValid = !isReviewsCount && recommended === null;
  if (isRecomendBlockValid) return null;

  return (
    <Space direction="vertical" align="start" justify="center" className={cn(styles.block, 'h-p-16 h-br-12')}>
      <Typography.Heading level={4}>{isReviewsCount ? reviewsCount : `${recommended}%`}</Typography.Heading>
      <Typography.Text size={14} className="h-color-D60">
        {description}
      </Typography.Text>
      <Icon className={styles.icon} icon={icon} />
    </Space>
  );
};
